import { ArrowRight, Phone } from "lucide-react";
import { Button } from "../ui/button";
import { COMPANY } from "../../data/products";

export default function CtaBanner() {
  return (
    <section
      data-testid="cta-banner"
      className="relative bg-zinc-950 text-white py-16 lg:py-20 overflow-hidden border-y-4 border-red-600"
    >
      <div className="absolute inset-0 bg-stripes-subtle opacity-30" />
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
        <div>
          <div className="flex items-center gap-3 mb-4">
            <span className="h-[2px] w-10 bg-red-500" />
            <span className="font-tech text-xs tracking-[0.3em] uppercase text-red-500 font-bold">
              Zamów dziś · wysyłka jutro
            </span>
          </div>
          <h3 className="font-display text-3xl sm:text-4xl lg:text-5xl uppercase leading-none tracking-tighter">
            Potrzebujesz wełny<br />
            <span className="text-red-500">na wczoraj?</span>
          </h3>
          <p className="mt-5 text-zinc-300 text-lg max-w-xl">
            Zadzwoń lub wyślij zapytanie — przygotujemy ofertę i potwierdzimy
            dostępność w ciągu godziny.
          </p>
        </div>
        <div className="flex flex-col sm:flex-row gap-4 lg:justify-end">
          <Button
            asChild
            className="rounded-none bg-red-600 hover:bg-red-700 text-white font-bold uppercase tracking-wider h-16 px-8 text-base"
            data-testid="cta-banner-quote"
          >
            <a href="#kontakt">
              Zamów wycenę
              <ArrowRight className="ml-2 h-5 w-5" />
            </a>
          </Button>
          <Button
            asChild
            variant="outline"
            className="rounded-none bg-transparent border-2 border-white text-white hover:bg-white hover:text-black font-bold uppercase tracking-wider h-16 px-8 text-base"
            data-testid="cta-banner-call"
          >
            <a href={`tel:${COMPANY.phone.replace(/\s/g, "")}`}>
              <Phone className="mr-2 h-5 w-5" />
              {COMPANY.phone}
            </a>
          </Button>
        </div>
      </div>
    </section>
  );
}
